const Content = {
  'services': {
    'qualitative': {
      'icons': [
        { 'iconName': 'focus-group', 'description': 'Focus Groups' },
        { 'iconName': 'microphone', 'description': 'In Depth Interviews (IDI\'s)'},
        { 'iconName': 'artboard', 'description': 'Ideation & Co-Creation Workshops' },
        { 'iconName': 'chat-bubbles', 'description': 'Expert Think Tanks (Roundtables)' },
        { 'iconName': 'list', 'description': 'In-person Intercepts' },
        { 'iconName': 'eye', 'description': 'Ethnography' },
        { 'iconName': 'center-arrows', 'description': 'Influencer Meetups' }
      ]
    },
    'quantitative': {
      'icons': [
        { 'iconName': 'speaker', 'description': 'Ad & Campaign Effectiveness' },
        { 'iconName': 'hand', 'description': 'Attitude & Usage' },
        { 'iconName': 'heart-settings', 'description': 'Brand Management' },
        { 'iconName': 'light-bulb-two', 'description': 'Concept Development' },
        { 'iconName': 'experiment-static', 'description': 'Creative Testing' },
        { 'iconName': 'star', 'description': 'Customer Satisfaction' },
        { 'iconName': 'line-graph', 'description': 'Forecasting & Demand Planning' },
        { 'iconName': 'shopping-bag', 'description': 'Path-to-Purchase' },
        { 'iconName': 'positioning', 'description': 'Positioning & Messaging' },
        { 'iconName': 'price-tag', 'description': 'Price & Feature Optimization' },
        { 'iconName': 'circle-graph', 'description': 'Segmentation' },
        { 'iconName': 'binoculars', 'description': 'Tracking' }
      ]
    },
    'storytelling': {
      'icons': [
        { 'iconName': 'graph-sheets', 'description': 'Visual Reporting' },
        { 'iconName': 'audience', 'description': 'Audience / Segment Profiles' },
        { 'iconName': 'video', 'description': 'Videography' },
        { 'iconName': 'graphs', 'description': 'Infographics' },
        { 'iconName': 'interactive-graphs', 'description': 'Interactive Dashboard' }
      ]
    }
  },
  'news': {
    'articleListFilters': {
      'icons': [
        { 'iconName': 'ic-lightbulb', 'description': 'Thought Leadership' },
        { 'iconName': 'chat', 'description': 'Industry Events'},
        { 'iconName': 'case-study', 'description': 'Cast Studies' },
        { 'iconName': 'logo-b', 'description': 'Company Highlights' },
        { 'iconName': 'megaphone', 'description': 'News' }
      ]
    }
  }
};

export { Content };
